import {secureModifier, wsHost} from "./url";

export const WebSocketBaseUrl = `ws${secureModifier}://${wsHost}`;

export enum KeyCardEventType {
	KeyCardOccupancyCreated = "keycard:KeyCardOccupancyCreated",
	KeyCardOccupancyUpdated = "keycard:KeyCardOccupancyUpdated",
}
